import {createColumnHelper} from '@tanstack/react-table';
import type {DataTableFeatures} from '@/components/ui/data-table-features.ts';

export type StockMatrixTableRow = {
	offerId: string;
	productName: string;
	quantities: Record<string, number>;
};

const columnHelper = createColumnHelper<DataTableFeatures, StockMatrixTableRow>();

function formatDayHeader(day: string): string {
	const [, month, date] = day.split('-');
	return `${date}.${month}`;
}

export function createStockMatrixColumns(days: string[]) {
	return columnHelper.columns([
		columnHelper.accessor('productName', {
			id: 'productName',
			header: 'Товар',
			cell: ({getValue}) => (
				<span className="line-clamp-3 text-left">{getValue()}</span>
			),
		}),
		...days.map((day) =>
			columnHelper.accessor((row) => row.quantities[day], {
				id: day,
				header: formatDayHeader(day),
				cell: ({getValue}) => {
					const value = getValue();
					return value === undefined ? '' : value;
				},
			}),
		),
	]);
}

export function mapStockMatrixRows(
	rows: {offerId: string; quantities: Record<string, number>}[],
	nameByOfferId: Map<string, string>,
): StockMatrixTableRow[] {
	return rows.map((row) => ({
		offerId: row.offerId,
		productName: productName(nameByOfferId, row.offerId),
		quantities: row.quantities,
	}));
}

function productName(names: Map<string, string>, offerId: string): string {
	const name = names.get(offerId)?.trim();
	if (name && name !== offerId) return name;
	return offerId;
}
